module.exports = __webpack_public_path__ + "img/km.bd2971aa.png";